import { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showModal, hideModal } from 'redux/actions/global';
import MODAL_TYPES from 'components/containers/Modal/Modals/types';
import { CAMERA_PERMISSION_EXPLANATION_TEXT } from 'consts';
import {
  requestVideoPermissionsFunc,
  requestAudioPermissionsFunc,
  requestBothPermissionsFunc
} from 'utilities';

let showExplanation = true;

export const PERMISSION_TYPE = {
  camera: 'camera',
  audio: 'audio',
  both: 'both'
};

const PERMISSION_TYPE_FUNC = {
  [PERMISSION_TYPE.camera]: requestVideoPermissionsFunc,
  [PERMISSION_TYPE.audio]: requestAudioPermissionsFunc,
  [PERMISSION_TYPE.both]: requestBothPermissionsFunc
};

export const useCamera = ({ withExplanation, permissionType }) => {
  const resultRef = useRef();
  const isUserMediaAvailableRef = useRef(!!navigator.mediaDevices?.getUserMedia);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const showExplanationDialog = photoType => {
    const text =
      CAMERA_PERMISSION_EXPLANATION_TEXT[photoType] ||
      CAMERA_PERMISSION_EXPLANATION_TEXT.default;

    dispatch(
      showModal({
        type: MODAL_TYPES.CAMERA_PERMISSION_EXPLANATION,
        props: {
          generalProps: {
            name: 'camera-permission-modal',
            subTitle: t(text),
            primaryButtonProps: {
              children: 'ok',
              onClick: () => {
                dispatch(hideModal());
              }
            }
          }
        }
      })
    );
  };

  const checkForExplanationDialog = photoType => {
    if (!showExplanation || !isUserMediaAvailableRef.current || resultRef.current) return;

    showExplanationDialog(photoType);
    showExplanation = false;
  };

  const requestPermissions = useCallback(async ({ tracker, photoType } = {}) => {
    resultRef.current = null;
    setTimeout(() => {
      if (withExplanation) {
        checkForExplanationDialog(photoType);
      }
    }, 500);

    const requestPermissionFunc = PERMISSION_TYPE_FUNC[permissionType];
    const result = await requestPermissionFunc(tracker);
    resultRef.current = result;

    return result;
  }, []);

  return { requestPermissions, isUserMediaAvailable: isUserMediaAvailableRef.current };
};
